import { action, observable, makeObservable } from "mobx";
import { toast } from "react-toastify";

export class ElectionDayDashboardStore {
    rootStore: any;

    electionDayDashboardData: any = null;
    downloadVoterData: any[] = [];

    isLoading: boolean = false;
    isError: boolean = false;

    showDataInModal: boolean = false;
    dataInModal: any = {};
    nameInModal: string = "";

    constructor(rootStore: any) {
        makeObservable(this, {
            electionDayDashboardData: observable,
            downloadVoterData: observable,
            isLoading: observable,
            isError: observable,
            showDataInModal: observable,
            dataInModal: observable,
            nameInModal: observable,

            getElectionDayDashboardData: action,
            getElectionDayDataDownload: action,

            setShowDataInModal: action,
            setDataInModal: action,
            setNameInModal: action,
        });

        this.rootStore = rootStore;
    }

    getElectionDayDashboardData = async (projectid: string) => {
        this.isLoading = true;
        this.isError = false;

        try {
            const res = await this.rootStore.api.post("voters/gotvdashboard", { projectid });

            this.electionDayDashboardData = res?.data || res;
        } catch (err) {
            console.error("Dashboard API error:", err);
            this.isError = true;
        } finally {
            this.isLoading = false;
        }
    };

    // getElectionDayDataDownload = async (projectid: string) => {
    //     this.isLoading = true;
    //     this.isError = false;
    //
    //     try {
    //         const res = await this.rootStore.api.post("voters/gotv_download_voters", { projectid });
    //
    //         this.downloadVoterData = res?.data || res;
    //     } catch (err) {
    //         console.error("Download API error:", err);
    //         this.isError = true;
    //     } finally {
    //         this.isLoading = false;
    //     }
    // };
    getElectionDayDataDownload = async (projectid: string) => {
        if (!projectid) {
            console.error("Project ID is missing");
            return;
        }

        this.isLoading = true;
        this.isError = false;

        try {
            const res = await this.rootStore.api.post(
                "voters/gotv_download_voters",
                { projectid },
                {
                    responseType: "blob", // 🔥 IMPORTANT for file download
                }
            );

            this.downloadVoterData = res?.data;
        } catch (err) {
            console.error("Download API error:", err);
            this.isError = true;
        } finally {
            this.isLoading = false;
        }
    };

    uploadVoterData = async (projectid: number, file: File) => {
        if (!projectid) {
            console.error("Project ID is missing");
            return;
        }
        this.isLoading = true;
        try {
            const formData = new FormData();
            formData.append("projectid", String(projectid));
            formData.append("file", file);

            const res = await this.rootStore.api.post("voters/gotv_upload_voters", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            console.log(res?.data, "response here");
            toast.success("uploaded successfully!");
            toast.success("updated " + (res?.data?.updated_rows || 0) + " rows");
            this.getElectionDayDashboardData(String(projectid)); // Refresh dashboard data after upload
            // this.downloadVoterData = res?.data;
        } catch (err) {
            console.error("Upload API error:", err);
            toast.error("Something went wrong during upload. Please try again.");
            this.isError = true;
        } finally {
            this.isLoading = false;
        }
    };

    setShowDataInModal(show: boolean) {
        this.showDataInModal = show;
    }

    setDataInModal(data: any) {
        this.dataInModal = data;
    }

    setNameInModal(name: string) {
        this.nameInModal = name;
    }

    get boothWiseData() {
        return this.electionDayDashboardData?.booth_wise || {};
    }

    get pivWiseData() {
        return this.electionDayDashboardData?.piv_level1_wise || {};
    }

    get acWiseData() {
        return this.electionDayDashboardData?.ac_wise || {};
    }
}
